export const ContractStatusCodesEnum = Object.freeze({
    ACTIVE : "Active",
    CANCELLED : "cancelled",
    DRAFT : "Draft",
    PENDING_TO_APPROVAL : "Pending Approval",
});